/* eslint-disable import/prefer-default-export */
import { TRegionKey } from '@source/interface';

const getCCPOQueryStringUrl = (region: TRegionKey) => {
  switch (region) {
    case 'th':
      return `exclusives=listing.is_ccpo`;
    case 'my':
      return `exclusives=listing.is_ccpo`;
    case 'jp': // Todo_CCPO: is_ccpo doesnt exist in the filter
      return '';
    case 'hk':
      return '';
    case 'id':
    case 'sg':
    default:
      return 'exclusives=listing.is_ccpo';
  }
};

export { getCCPOQueryStringUrl };
